import React from "react";
import { useField, FieldConfig } from "formik";
import styled from "styled-components";
import { TitleText, LabelText } from "./Text";

interface Props {
  label?: string;
}

export const RadioInput = ({ label, ...props }: Props & FieldConfig) => {
  const [field, meta] = useField(props);
  return (
    <RadioContainer>
      <RadioLabel>
        <input
          id={`${field.name}${field.value}`}
          {...field}
          {...props}
          style={{
            visibility: "hidden",
            opacity: 0,
            cursor: "pointer",
            position: "absolute",
          }}
        />
        <InnerRadius isSelected={!!field.checked} />
      </RadioLabel>
      <LabelText color="#000" htmlFor={`${field.name}${field.value}`}>
        {label}
      </LabelText>
    </RadioContainer>
  );
};
const RadioContainer = styled.div`
  display: grid;
  grid-template-columns: 1.5em auto;
  align-items: center;
  margin-right: 2em;
`;
const RadioLabel = styled.label`
  height: 1em;
  width: 1em;
  border: 2px solid #2296f3;
  border-radius: 50%;
`;
const InnerRadius = styled.div<{ isSelected: boolean }>`
  height: 0.8em;
  width: 0.8em;
  background-color: ${(props) => (props.isSelected ? "#2296f3" : "#fff")};
  transform: translate(0.1em, 0.1em);
  border-radius: 50%;
`;
